// SSR-safe accessors for browser globals used during render.
// On the server there is no window; fall back to the canonical site origin.
const CANONICAL_ORIGIN = "https://www.kreditkarten.de";

export function getSiteOrigin(): string {
  return typeof window !== "undefined" ? window.location.origin : CANONICAL_ORIGIN;
}

export function getPageUrl(pathname?: string): string {
  if (typeof window !== "undefined") return window.location.href;
  return pathname ? `${CANONICAL_ORIGIN}${pathname}` : CANONICAL_ORIGIN;
}
